import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=3b00125a&scoped=true&"
import script from "./CommonButton.vue?vue&type=script&lang=ts&"
export * from "./CommonButton.vue?vue&type=script&lang=ts&"
import style0 from "./CommonButton.vue?vue&type=style&index=0&id=3b00125a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b00125a",
  null
  
)

export default component.exports